export enum GenericConsentTypeUrlParam {
  EULA = 'eula',
  PRIVACY_POLICY = 'privacy-policy',
  ANALYTICS = 'analytics',
}
